module.exports = __webpack_public_path__ + "static/media/adapay-gif.38b72413.gif";